import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import SubHead from '../SubHead/SubHead';
import MiniHed from '../SubHead/MiniHed';
import BodyText from '../BodyText/BodyText';
import Button from '../../../common/Button';
import ProsCons from './ProsCons';
import { getFileName, isValid, isText, decodeSpecialCharacters, segmentTrackEvent, getRelValue } from '../../../../utils';
import { appendImgixParamsArticle } from '../../../../imgixUtils';
import './image-module.scss';
import { PinterestShareButton } from 'react-share';

const ProductModule = ({
  data, className, isMobile, additionalClassName, fullUrl=null, articleLayout, isAffiliate, seo, productSummary,
}) => {
  if (!isValid(data)) { return null; }
  const {
    imageSrcDesktop,
    imageSrcMobile,
    name,
    title,
    brand,
    sponsored,
    imageAlt,
    imageMobileCredit,
    imageMobileCreditURL,
    imageMobileCaption,
    imageMobileCaptionURL,
    mobileHeight,
    pinterestImageOverride,
    photoCredit,
    photoCreditUrl,
    photoCaption,
    photoCaptionUrl,
    prosCons,
    showProsCons,
    salesSticker,
    id = false,
  } = data;

  const hasSalesSticker = isText(salesSticker);
  const stickerSrc = 'https://www.purewow.com/static-gmg/purewow/images/on+sale+sticker.webp';
  const renderedSalesSticker = hasSalesSticker ? <img className='sales-sticker' src={stickerSrc} alt='sales sticker' loading='lazy' /> : null;

  let {
    pinterestHide = false,
    price,
    oldPrice,
    bodyText
  } = data;

  oldPrice = isValid(oldPrice) ? `$${oldPrice}` : null;
  price = isValid(price) ? `$${price}` : null;
  const imageSrc = (isMobile && isValid(imageSrcMobile)) ? imageSrcMobile : isValid(imageSrcDesktop) ? imageSrcDesktop : null;
  const renderedImage = (imageSrc !== null) ? <img className={className} src={imageSrc} alt={isText(imageAlt) ? imageAlt : getFileName(imageSrc)} loading="lazy"/> : null;

  const renderedProsCons = isValid(prosCons) ? <ProsCons prosCons={prosCons} isMobile={isMobile} showProsCons={showProsCons} /> : null;

  const { buttonText, buttonUrl, imageUrl } = data;
  const button = {
    text: buttonText,
    price,
    oldPrice,
    url: buttonUrl,
  };
  const getIsButton = () => {
    let { text, url } = button;
    if ((isText(text)) && (isText(url))) {
      return true;
    }
    return false;
  };
  const isButton = getIsButton();
  const isStandard = (articleLayout === 'Standard');
  const imageUrlVariable = decodeSpecialCharacters(imageUrl);
  const imageUrlRel = getRelValue(imageUrlVariable);
  // console.log(`imageUrlVariable: ${imageUrlVariable} and imageUrlRel: ${imageUrlRel}`);
  
  const renderedButton = (isButton) ? <Button button={button} isStandard={isStandard} sponsoredRel={isButton ? true : false}/> : null;
  // const renderedOldPrice = oldPrice ? <span className='old-price'><span>{oldPrice}</span>,&nbsp;</span> : '';
  // const renderedPrice = price ? <span className='body-text'>{renderedOldPrice}{price}</span> : null;
  const pinMedia = isValid(pinterestImageOverride) ? pinterestImageOverride : imageSrc;
  const showPin = (fullUrl && pinMedia);

  const credit = (isValid(imageMobileCredit) && isMobile) ? imageMobileCredit : isValid(photoCredit) ? photoCredit : null;
  const caption = (isValid(imageMobileCaption) && isMobile) ? imageMobileCaption : isValid(photoCaption) ?  photoCaption : null;
  const creditUrl = (isValid(imageMobileCreditURL) && isMobile) ? imageMobileCreditURL : isValid(photoCreditUrl) ? photoCreditUrl : null;
  const captionUrl = (isValid(imageMobileCaptionURL) && isMobile) ? imageMobileCaptionURL : isValid(photoCaptionUrl) ? photoCaptionUrl : null;
  const captionUrlRel = getRelValue(captionUrl);
  const creditUrlRel = getRelValue(creditUrl);


  const containerClassName = additionalClassName ? `${className}-container ${additionalClassName}` : `${className}-container`;

  const productDataClassName = isStandard ? 'product-data standard' : 'product-data';
  const SubHeadTitleClass = isStandard ? 'sub-head title standard' : 'sub-head title';
  const SubHeadNameClass = isStandard ? 'sub-head name standard' : 'sub-head name';
  
  let relFind = 'class="wp-block-button__link"';
  let relReplace = 'class="wp-block-button__link" data-link-type="buy-button"';
  if (isValid(bodyText) && bodyText.includes(relFind)) {
    try {
      bodyText = bodyText.replaceAll(relFind, relReplace);
    }
    catch(err) {
      console.log(err);
      let relVal = new RegExp(relFind, 'g');
      bodyText = bodyText.replace(relVal, relReplace);
    }
  }

  if (!renderedImage || !showPin) {
    pinterestHide = true;
  }

  const renderedId = (isAffiliate && id === '1') ? 'reviews' : id;

  return (
    <div className={containerClassName} {...id && { id: renderedId }}>
      <div className="image-wrapper">
        {imageUrlVariable ? (
          <a className="large-product-link" href={imageUrlVariable} target="_blank" rel={imageUrlRel} data-link-type="image-link" >
            <div className={`img-container-${className}`}>
              <a className="large-product-link" href={imageUrlVariable} target="_blank" rel={imageUrlRel} data-link-type="image-link" >
                {renderedImage}
                {renderedSalesSticker}
                </a>
              { !pinterestHide && 
                <div className="social-pin-wrapper">
                  <PinterestShareButton
                    className="social-share-unit pinterest"
                    onClick={() => segmentTrackEvent('pinterest_share', {action: 'social', label: 'pin_share'})}
                    url={fullUrl}
                    alt={imageAlt || 'pinterest share image'}
                    description={seo.metaDescription}
                    media={pinMedia || 'https://www.purewow.com/static-gmg/purewow/logos/purewow-mark-salmon.jpg'}>
                  </PinterestShareButton>
                </div>
              }
              {sponsored && <span className="sponsored-txt">SPONSORED</span>}
            </div>
          </a>
        ) : (
          <div 
            className={`img-container-${className}`}
            style={
            isValid(mobileHeight)
              ? { minHeight: isMobile ? mobileHeight / 2 : mobileHeight }
              : undefined
            }>
            {renderedImage}
            { !pinterestHide && 
              <div className="social-pin-wrapper">
                <PinterestShareButton
                  className="social-share-unit pinterest"
                  onClick={() => segmentTrackEvent('pinterest_share', {action: 'social', label: 'pin_share'})}
                  url={fullUrl}
                  alt={imageAlt || 'pinterest share image'}
                  description={seo.metaDescription}
                  media={imageSrc || 'https://www.purewow.com/static-gmg/purewow/logos/purewow-mark-salmon.jpg'}>
                </PinterestShareButton>
              </div>
            }
            {sponsored && <span className="sponsored-txt">SPONSORED</span>}
          </div>
        )}
          <div className="img-credit-container ">
            {captionUrl ? (
              <a href={captionUrl} className="caption" target="_blank" rel={captionUrlRel} data-link-type="caption-link">{caption}</a>
            ) : (
              <span className="caption">{caption}</span>
            )}

            {(caption && credit) && <span className="img-credit"> / </span>}

            {creditUrl ? (
              <a href={decodeSpecialCharacters(creditUrl)} className="img-credit" target="_blank" rel={creditUrlRel} data-link-type="credit-link" dangerouslySetInnerHTML={ { __html: credit } }></a>
            ) : (
              <span className="img-credit" dangerouslySetInnerHTML={ { __html: credit } }></span>
            )}
          </div>
      </div>
      <div className="image-text-wrapper">
        <div className={productDataClassName}>
          {isText(title)  &&
            <MiniHed className={SubHeadTitleClass} data={title} isSuperlative={true}/>
          }
          {isText(name) &&
             <Fragment>
              <SubHead className={SubHeadNameClass} data={name}/>
            </Fragment>
          }
          {showProsCons && renderedProsCons}
          {isText(brand) &&
            <div className="sub-head-wrapper">
              <MiniHed className="sub-head brand" data={brand}/>
            </div>
          }
        </div>
        <BodyText className="body-text" articleLayout={articleLayout} data={bodyText} isAffiliate={isAffiliate} hasBuyButton={true}/>
        {renderedButton}
      </div>
    </div>
  );
};

ProductModule.propTypes = {
  data: PropTypes.object,
  className: PropTypes.string,
  isMobile: PropTypes.bool,
};

export default ProductModule;
